import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import iconPath from '../../assets/iconsLib'

export const Icon = ({
 size, color, viewBox, icon, className, testId 
}) => (
  <svg
    className={`inline-block align-middle ${className} text-${color}`}
    viewBox={viewBox}
    width={`${size}`}
    height={`${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid={testId}
  >
    <path fillRule="evenodd" clipRule="evenodd" fill={color.includes('#') ? color :'currentColor'} d={iconPath[icon]} />
  </svg>
)


Icon.defaultProps = {
  size: 22,
  color: '',
  viewBox: '0 0 32 32',
  className: '',
  testId:'icon'
}

Icon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  viewBox: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string
}

const IconWithRef = forwardRef((props, ref) => <Icon {...props} forwardedRef={ref} />)
export default IconWithRef
